import { atom } from 'recoil';

import { CheckBoxFilter } from '@shared/components/CheckboxFilter';
import dayjs from 'dayjs';

export const agencyAdminAccountTeamNameFilterAtom = atom<CheckBoxFilter | null>({
  key: 'agencyAdminAccountTeamNameFilterAtom',
  default: {},
});

export const agencyAdminAccountSelectYearAtom = atom<dayjs.Dayjs | null>({
  key: 'agencyAdminAccountSelectYearAtom',
  default: null, // 기본값을 null로 설정하여 최근 3개월만 보이도록
});
